import SwiperSlider from './SwiperSlider';
import { $body } from '../Constants';

/**
 * Annual Highlights
 */
const AnnualHighlights = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		ANNUAL_HIGHLIGHTS: '.annual-highlights .swiper-container',
	};

	/**
	 * Annual Highlights
	 *
	 * @class
	 * @augments SwiperSlider
	 */
	class AnnualHighlights extends SwiperSlider {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this.setOptions({
				spaceBetween: 30,
				slidesPerView: 4,
				slidesPerGroup: 4,
				loopFillGroupWithBlank: true,
				grabCursor: true,
				loop: true,
				speed: 1500,
				autoplay: {
					delay: 10000,
					disableOnInteraction: false,
					pauseOnMouseEnter: false
				},
				pagination: {
					el: this.$element.find(this.constructor.Selector.PAGINATION),
					clickable: true
				},
				navigation: {
					nextEl: this.$element.closest('.annual-highlights').find('.swiper-button-next').get(0),
					prevEl: this.$element.closest('.annual-highlights').find('.swiper-button-prev').get(0),
				},
				breakpoints: {
					1600: {
						slidesPerView: 4,
						slidesPerGroup: 4
					},
					1200: {
						slidesPerView: 3,
						slidesPerGroup: 3
					},
					1023: {
						slidesPerView: 2,
						slidesPerGroup: 2
					},
					550: {
						slidesPerView: 1,
						slidesPerGroup: 1
					}
				}
			});

			this._initialize();

			this.$element.find('.swiper-wrapper').on('mouseenter', () => {
				this.slider.autoplay.stop();
			});

			this.$element.find('.swiper-wrapper').on('mouseleave', () => {
				this.slider.autoplay.start();
			});

			/*const $section = this.$element.closest('.main');
			const $nextSection = $section.closest('.frame').next('.frame').find('.main');

			if ($section.length && $nextSection.length) {
				const setPadding = () => {
					$section.css('padding-bottom', '');
					$nextSection.css('padding-top', '');

					if ($(window).width() < 1440) {
						const sectionPadding = parseFloat(window.getComputedStyle($section.get(0)).paddingTop);
						$section.css('padding-bottom', `${this.$element.outerHeight() / 2 + sectionPadding}px`);

						const nextSectionPadding = parseFloat(window.getComputedStyle($nextSection.get(0)).paddingTop);
						$nextSection.css('padding-top', `${this.$element.outerHeight() / 2 + nextSectionPadding}px`);
					}
				};

				setPadding();

				$(window).on('resize', () => {
					setPadding();
				});
			}*/
		}
	}

	return AnnualHighlights._getElements($body.find(Selector.ANNUAL_HIGHLIGHTS), AnnualHighlights);
})();

export default AnnualHighlights;
